import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link, useParams } from "react-router-dom";
import { baseUrl } from "../Univ.js";

function OpDoc() {
  const { dept_id } = useParams(); // 👈 department id from URL
  const [consData, setConsData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios
      .get(baseUrl + "cons-search/")
      .then((response) => {
        // FILTER doctors by department id
        const filtered = response.data.filter(
          (doc) => String(doc.department) == String(dept_id)
        );

        setConsData(filtered);
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  }, [dept_id]);

  return (
    <section className="container mt-4">
      <h3
        className="text-center"
        style={{ color: "white", backgroundColor: "#0dcaf0" }}
      >
        <i
          className="fa-solid fa-stethoscope"
          aria-hidden="true"
          style={{ color: "red" }}
        ></i>{" "}
        Select Doctor
      </h3>

      {loading ? (
        <p className="text-center mt-4">Loading doctors...</p>
      ) : consData.length === 0 ? (
        <p className="text-center mt-4 text-danger">
          No doctors available for this department
        </p>
      ) : (

        <div className="row nurseInpatient">
          <div className="col-md-12">
            {consData.map((consultant) => (
              <div className="btn-group mb-2" key={consultant.id}>
                <Link to={`/fix-appointment/${consultant.id}`}>
                  <button type="button" className="btn btn">
                    <i className="fa fa-stethoscope fa-2x"></i>
                    <span style={{ fontSize: "20px" }}>
                        <br/>
                      <small>{consultant.consultant}</small>

                    </span>
                  </button>
                </Link>
              </div>
            ))}
          </div>
        </div>
      )}
    </section>
  );
}

export default OpDoc;
